import { render, staticRenderFns } from "./consultarOficio.vue?vue&type=template&id=7eced839"
import script from "./consultarOficio.vue?vue&type=script&lang=js"
export * from "./consultarOficio.vue?vue&type=script&lang=js"
import style0 from "./consultarOficio.vue?vue&type=style&index=0&id=7eced839&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports